import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { MenuBarComponent } from './menu-bar.component';
import { MenuModule } from '@syncfusion/ej2-angular-navigations';

@NgModule({
  declarations: [
    MenuBarComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MenuModule,
  ],
  exports: [
    MenuBarComponent,

  ]
})
export class MenuBarModule {}
